import { Extension } from '@tiptap/core';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

/** Same pattern as `@manta/shared/mail/template-placeholders`. */
const PLACEHOLDER = /\[[^[\]<>\n]{1,80}\]/g;

function placeholderDecorations(doc: ProseMirrorNode): DecorationSet {
  const decorations: Decoration[] = [];
  doc.descendants((node, pos) => {
    if (!node.isText || !node.text) return;
    for (const match of node.text.matchAll(PLACEHOLDER)) {
      const from = pos + (match.index ?? 0);
      decorations.push(
        Decoration.inline(from, from + match[0].length, {
          class: 'rte-placeholder',
        }),
      );
    }
  });
  return DecorationSet.create(doc, decorations);
}

/** Highlights unfilled `[...]` placeholders without changing the document. */
export const BracketPlaceholder = Extension.create({
  name: 'bracketPlaceholder',

  addProseMirrorPlugins() {
    const key = new PluginKey<DecorationSet>('bracketPlaceholder');
    return [
      new Plugin<DecorationSet>({
        key,
        state: {
          init: (_, { doc }) => placeholderDecorations(doc),
          apply: (tr, decorations) =>
            tr.docChanged ? placeholderDecorations(tr.doc) : decorations,
        },
        props: {
          decorations: (state) => key.getState(state),
        },
      }),
    ];
  },
});
